import { useMemo } from "react";
import { Box } from "@mui/material";
import { useEditor, useNode } from "@craftjs/core";
import EmptyState from "@/components/EmptyState";
import RegionSettings from "../settings/RegionSettings";
import useNormalizeSpacing from "../settings/SpacingSettings/useNormalizeSpacing";
import { Spacing } from "../settings/SpacingSettings/SpacingSettings";
import { useAccessControl } from "@/features/access-control";
import { useAppSelector } from "@/hooks";
import { Content, ContentStatus, ContentType, Offer } from "@/types";

interface RegionBlockProps extends Spacing {
  region: string;
}

const RegionBlock = (props: RegionBlockProps) => {
  const spacing = useNormalizeSpacing(props);
  const { isActiveUserAdmin } = useAccessControl();
  const organizationId = useAppSelector((store) => store.ui.activeOrganization);
  const currentOrganization = useAppSelector((store) => store.organizations[organizationId] ?? null);

  const {
    id,
    connectors: { connect, drag },
  } = useNode();

  const { query } = useEditor();
  const isEditorEnabled = query.getOptions().enabled;

  const content = useMemo(() => {
    if (!currentOrganization?.content?.length) return [];

    return currentOrganization?.content.filter((content: Content) => {
      if (!("region" in content)) return false;

      if (content.status === ContentStatus.PUBLISHED && content.region === props?.region) {
        return content;
      }
    });
  }, [currentOrganization?.content, props?.region]);

  if (!content.length) {
    return isActiveUserAdmin && isEditorEnabled ? (
      <Box padding={3} ref={(ref: any) => connect(drag(ref))}>
        <EmptyState title="Cabecera" description="Apunta contenidos como ofertas o anuncios a esta región, para verlos aquí" />
      </Box>
    ) : null;
  }

  return (
    <div key={`${id}`} ref={(ref: any) => connect(drag(ref))} className="offer-container" style={{ ...spacing } as React.CSSProperties}>
      {content
        .filter((item: any): item is Offer => item.type === ContentType.OFFER && item.component === 'image')
        .map((offer: Offer) => (
          <div key={offer.id}>
            <img src={offer.images[0]} alt={offer.title} />
          </div>
        ))}
    </div>
  );
};

RegionBlock.craft = {
  displayName: "Region",
  related: {
    settings: RegionSettings,
  },
};

export default RegionBlock;
